import { TabsProps, Badge } from "antd";

interface ItemProps {
  activePromoTable: React.ReactNode;
  privatePromoTable: React.ReactNode;
  expiredPromoTable: React.ReactNode;
  activeCount?: number;
  privateCount?: number;
  expiredCount?: number;
}

const promoTabItems: (itemProps: ItemProps) => TabsProps["items"] = (itemProps) => [
  {
    key: "1",
    label: (
      <span>
        Active Discounts{" "}
        {itemProps.activeCount != null && (
          <Badge
            count={itemProps.activeCount}
            overflowCount={999}
            style={{ backgroundColor: "#52c41a", marginLeft: 4 }}
          />
        )}
      </span>
    ),
    children: <div>{itemProps.activePromoTable}</div>,
  },
  {
    key: "2",
    label: (
      <span>
        Private Discounts{" "}
        {itemProps.privateCount != null && (
          <Badge
            count={itemProps.privateCount}
            overflowCount={999}
            style={{ backgroundColor: "#722ed1", marginLeft: 4 }}
          />
        )}
      </span>
    ),
    children: <div>{itemProps.privatePromoTable}</div>,
  },
  {
    key: "3",
    label: (
      <span>
        Expired Discounts{" "}
        {itemProps.expiredCount != null && (
          <Badge
            count={itemProps.expiredCount}
            overflowCount={999}
            style={{ backgroundColor: "#8c8c8c", marginLeft: 4 }}
          />
        )}
      </span>
    ),
    children: <div>{itemProps.expiredPromoTable}</div>,
  },
];

export default promoTabItems;
